import React, { useState } from "react";
import { RefCard, RangeIcon } from "./refParts";
import { bookClass, isOpen, bySr, getExposureFrom } from "./refUtils";
import { formatBook } from "../../../utils/formatOdds";

const POKER_ICON = `${import.meta.env.BASE_URL}img/poker.png`;
const REMARK_ICON = `${import.meta.env.BASE_URL}assets/img/icons/remark.png`;

/**
 * Poker 1-Day (poker) bet table in the reference admin's markup — rendered inside `.casino-detail`:
 *   .playerabox (Player A back/lay + book + 2/7 Cards Bonus) · .playerabcardbox (poker icon + A/B cards)
 *   · .playerbbox (Player B ...) · .casino-remark (when the feed has a remark)
 * Markets like the reference: player = sub subtype "poker", cardBonus = subtype "pokerfancy", by sr.
 * Styled by the ported reference rules in styles/index.css (.poker1day ...).
 */
export default function BetTablePoker({ data = [], cards = [], remark, onBetClick, exposures = {} }) {
  const [openRange, setOpenRange] = useState({});
  const toggle = (id) => setOpenRange((s) => ({ ...s, [id]: !s[id] }));

  const sub = Array.isArray(data) ? data : [];
  const player = bySr(sub.filter((m) => m?.subtype === "poker"));
  const cardBonus = bySr(sub.filter((m) => m?.subtype === "pokerfancy"));

  const click = (m, value, type) => {
    if (!m || !isOpen(m)) return;
    onBetClick?.(value, m.nat, type, m);
  };
  const book = (m, extra = "") => {
    const exp = getExposureFrom(exposures, m?.nat);
    return <span className={`${extra}casino-book ${bookClass(exp)}`}>{formatBook(exp)}</span>;
  };

  const box = (side, p, b2, b7, ids) => (
    <div className={`player${side}box`}>
      <div className={`casino-box-row player${side}fabcy`}>
        <div className="casino-nation-name">
          <div className="float-left mr-2">
            <RangeIcon id={ids[0]} market={p} open={!!openRange[ids[0]]} onToggle={toggle} />
          </div>{" "}
          <b>{side === "a" ? "Player A" : "Player B"}</b>
        </div>{" "}
        <div className="casino-bl-box">
          <div className={`back casino-bl-box-item${isOpen(p) ? "" : " suspended"}`} onClick={() => click(p, p?.b, "back")}>
            <span className="casino-box-odd">{p?.b}</span>
          </div>{" "}
          <div className={`lay casino-bl-box-item${isOpen(p) ? "" : " suspended"}`} onClick={() => click(p, p?.l, "lay")}>
            <span className="casino-box-odd">{p?.l}</span>
          </div>
        </div>
      </div>{" "}
      <div className="casino-nation-name text-center w-100">{book(p)}</div>{" "}
      <div className="casino-box poker1dayother mt-2">
        <div className="casino-bl-box">
          <div className="odds-min-max">
            <span className="float-right casino-min-max pr-2">
              <RangeIcon id={ids[1]} market={b2} open={!!openRange[ids[1]]} onToggle={toggle} />
            </span>
          </div>{" "}
          <div className="odds-min-max pl-2">
            <span className="float-right casino-min-max">
              <RangeIcon id={ids[2]} market={b7} open={!!openRange[ids[2]]} onToggle={toggle} />
            </span>
          </div>
        </div>{" "}
        <div className="casino-bl-box">
          <div className={`casino-bl-box-item back${isOpen(b2) ? "" : " suspended"}`} onClick={() => click(b2, b2?.b, "back")}>
            <span className="casino-box-odd">2 Cards Bonus</span>
          </div>{" "}
          <div className={`casino-bl-box-item back${isOpen(b7) ? "" : " suspended"}`} onClick={() => click(b7, b7?.b, "back")}>
            <span className="casino-box-odd">7 Cards Bonus</span>
          </div>
        </div>{" "}
        <div className="casino-bl-box">
          <div className="odds-min-max">{book(b2)}</div> <div className="odds-min-max">{book(b7)}</div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {box("a", player[0], cardBonus[0], cardBonus[1], ["demo1", "demo2", "demo3"])}{" "}
      <div className="playerabcardbox">
        <div className="poker-icon">
          <img src={POKER_ICON} alt="" />
        </div>{" "}
        <div className="row row5 w-100">
          <div className="col-12 col-md-6">
            <div className="dealer-name playera">Player A</div>{" "}
            <div className="mt-1">
              <RefCard card={cards[0]} /> <RefCard card={cards[1]} />
            </div>
          </div>{" "}
          <div className="col-12 col-md-6 text-right">
            <div className="dealer-name playerb">Player B</div>{" "}
            <div className="mt-1">
              <RefCard card={cards[2]} /> <RefCard card={cards[3]} />
            </div>
          </div>
        </div>
      </div>{" "}
      {box("b", player[1], cardBonus[2], cardBonus[3], ["demo4", "demo5", "demo6"])}{" "}
      {remark != null && remark !== "" && (
        <div className="casino-remark mt-3">
          <div className="remark-icon">
            <img src={REMARK_ICON} alt="" />
          </div>{" "}
          {React.createElement("marquee", null, remark)}
        </div>
      )}
    </>
  );
}
